import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B'];

const CustomerDeepDive = ({ data }) => {
    if (!data) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Customer Deep Dive</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total Customers</small>
                            <strong>{data.total_customers}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total Orders</small>
                            <strong>{data.total_orders}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Avg Orders/Customer</small>
                            <strong>{data.avg_orders_per_customer}</strong>
                        </div>
                    </div>
                </div>

                {data.order_frequency && data.order_frequency.length > 0 && (
                    <div className="mb-3">
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Order Frequency Distribution</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Segment</th>
                                        <th className="text-end">Customers</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.order_frequency.map((seg, i) => (
                                        <tr key={i}>
                                            <td>{seg.segment}</td>
                                            <td className="text-end">{seg.count}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {data.by_area && data.by_area.length > 0 && (
                    <div>
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Customers by Area</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Area</th>
                                        <th className="text-end">Customers</th>
                                        <th className="text-end">Revenue</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.by_area.slice(0, 10).map((a, i) => (
                                        <tr key={i}>
                                            <td>{a.area}</td>
                                            <td className="text-end">{a.customer_count}</td>
                                            <td className="text-end">{a.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomerDeepDive;
